/**
 * 道闸信息
 */
import React from "react";

import { Button, Row, Col, Icon, Tooltip } from "antd";

import PageLayout from "../../ui/PageLayout";
import ParkGateEdit from "./ParkGateEdit";
import QR from "./ParkGateQR";
import http from "../../../axios/http";
import BizParkConfig from "../bizParkConfig/BizParkConfig";
import { global_data } from '../../ui/auth'

class ParkGateIndex extends React.Component {
  columns = [
    {
      title: "道闸编号",
      dataIndex: "gateNo",
      width: "15%",
    },
    {
      title: "道闸名称",
      dataIndex: "name",
      width: "20%",
    },
    {
      title: "类型",
      dataIndex: "type",
      width: "10%",
      format: {
        0: "不控制",
        1: "交易车",
        2: "社会车",
        3: "服务站",
        21: "场中场交易车",
        23: "场中场服务站",
      },
    },
    {
      title: "所在区域",
      dataIndex: "zone",
      width: "20%",
      render: (text, record, index) => {
        var zoneName = "";
        this.state.parkZones.forEach((row) => {
          if (row.code === text) {
            zoneName = row.name;
          }
        });
        return zoneName;
      },
    },
    {
      title: "方向",
      dataIndex: "isOut",
      width: "10%",
      format: { false: "入", true: "出" },
    },
    {
      title: "操作",
      dataIndex: "id",
      width: "10%",
      render: (text, record, index) => (
        <div>
          {global_data.authCode.includes("BARRIER_PARK_GATE_UPDATE")?
          <Tooltip title="修改">
            <Icon
              type="edit"
              theme="filled"
              title="修改"
              className="table-operate-icon"
              onClick={this.update.bind(this, record)}
            />
          </Tooltip>
          :""}
          <Tooltip title="小程序码">
            <Icon
              type="picture"
              theme="filled"
              title="小程序码"
              className="table-operate-icon"
              onClick={this.doShowQR.bind(this, record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  loadParkZone = () => {
    http.post({
      url: "/barrier/parkZone/allZone",
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };

  componentWillMount() {
    this.loadParkZone();
  }

  state = {
    visible: false,
    showQR: false,
    configVisible: false,
    editData: {},
    parkZones: [],
    loadData: "",
  };

  openConfig = () => {
    this.setState({ configVisible: true });
  };

  hideConfig = () => {
    this.setState({ configVisible: false });
  };

  add = () => {
    this.setState({ editData: {} });
    this.showModal();
  };

  showModal = () => {
    this.setState({ visible: true });
  };
  hiddenModal = () => {
    this.setState({ visible: false });
  };

  update = (info, e) => {
    this.setState({ editData: info });
    this.showModal();
  };

  doShowQR = (info, e) => {
    this.setState({ editData: info });
    this.setState({ showQR: true });
  };

  hideQR = () => {
    this.setState({ showQR: false });
  };

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={24} style={{ textAlign: "right" }}>
                <Button
                  onClick={this.openConfig.bind(this)}
                  type="primary"
                  style={{ marginRight: "10px" }}
                >
                  市场停车配置
                </Button>
                {global_data.authCode.includes("BARRIER_PARK_GATE_ADD")?
                <Button type="primary" onClick={this.add}>
                  新增
                </Button>
                :""}
              </Col>
            </Row>
          }
          rowKey="code"
          url="/barrier/parkgate/query"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <ParkGateEdit
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          editData={this.state.editData}
          successCallback={this.state.loadData}
        />
        <QR
          visible={this.state.showQR}
          onCancel={this.hideQR.bind(this)}
          editData={this.state.editData}
        />
        <BizParkConfig
          visible={this.state.configVisible}
          onCancel={this.hideConfig.bind(this)}
        />
      </div>
    );
  }
}

export default ParkGateIndex;
